// extracted by mini-css-extract-plugin
export default {"Container":"Snackbar_Container__k+n6L","ContainerAnimateIn":"Snackbar_ContainerAnimateIn__pXJsN"};